import styled from 'styled-components'
import { Arrow } from  '../../assets'
import { ellipsis } from 'polished'

export const Container = styled.div`
  width: 100%;
  height: 100%;
  min-width: 230px;
  cursor: pointer;
  padding: 13px 10px 10px 10px;
  border: solid 1px #f4f6f6;
  transition: all .5s ease;
  box-sizing: border-box;
  color: #112426;

  @media (min-width: 768px) { 
    padding: 13px 13px 0 13px;
    height: 267px;
    border: solid 1px transparent;

    &:hover {
      border: solid 1px #f4f6f6;

      .title {
        transform: translateY(10px);
      }

      .arrow {
        opacity: 1;
        background-position: 0px 0px;
      }

      .description {
        opacity: 1;
      }

      .image {
        height: 52px;
        &:after {
          background: #80aaa7;
        }
      }
    }
  }
`

export const ImageContainer = styled.div`
  position: relative;
  width: 100%;
  height: 228px;
  background: url(${p => p.src}) no-repeat center center, #AEDBD9;
  background-size: cover;
  transition: all .3s ease-in-out; 

  @media (min-width: 768px) { 
    height: 172px;
  }

  &:after {
    position: absolute;
    content: '';
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #AEDBD9;
    mix-blend-mode: soft-light;
    transition: all .3s ease-in-out; 
  }
`

export const TitleContainer = styled.div`
  position: relative;
  width: 100%;
  height: 40px;
  padding: 0 0px;

  .title-component {
    /* ${ellipsis(p => (p.width - 20) + "px")} */
    max-width: 90%;
    display: inline-block;
    /* text-overflow: ellipsis; */
    white-space: pre-wrap;
    word-wrap: normal;
    font-size: 12px;
  }

  @media (min-width: 768px) {
    padding: 0;
    font-size: 11px;
  }
`
export const DescriptionContainer = styled.div`
  position: relative;
  display: flex; 
  width: 100%;
  min-height: 40px;

  .description {
    margin-top: 6px !important;
    ${ellipsis(p => p.width + "px", 8)}
  }
`

export const ArrowLeft = styled.div`
  position: absolute;
  top: 38px;
  right: -16px;
  width: 40px;
  min-height: 20px;
  background: url(${Arrow}) no-repeat;
  background-position: 0px 0px;
  transition: all .3s ease-in-out;
  transform: scale(.7);
  z-index: 0;

  @media (min-width: 768px) {
    top: 16px;
  }
`